export const SettingName = Object.freeze({
  AppVersion: 'App Version',
  Transtek: 'Transtek',
  AIGuidedScreeningsCountLimit: 'AI Guided Screenings Count Limit',
});
